import axios from "axios";
import React, { useEffect, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";

async function getConsensusChartData(company_id, year) {
  const revenues = [];
  const operatingProfits = [];
  await axios
    .get(
      `/api/consensus?year=${year}&company_id=${company_id}`
    )
    .then((res) => {
      res.data.forEach((item) => {
        revenues.push({
          x: Date.parse(item.date),
          y: Number(item.revenue?.toFixed(2)),
        });
        operatingProfits.push({
          x: Date.parse(item.date),
          y: Number(item.operatingProfit?.toFixed(2)),
        });
      });
    });

  return { revenues, operatingProfits };
}
async function getStockChartData(company_id) {
  const newdata = [];
  await axios
    .get(
      `/api/stockprice/company_id/${company_id}/limit/600`
    )
    .then((res) => {
      res.data.forEach((item) => {
        newdata.push({
          x: Date.parse(item.date), // milliseconds 단위
          open: item.open,
          high: item.high,
          low: item.low,
          close: item.close,
        });
      });
    });

  return newdata;
}

export default function ConsensusChart({ company_id, name }) {
  const base_options = {
    // 기초스타일
    title: {
      style: {
        color: "#111827",
        fontWeight: "bold",
      },
      text: `${name} 컨센서스 추이`,
    },
    chart: {
      // 차트 스타일 설정
      type: "spline",
      backgroundColor: "transparent",
      // backgroundColor: "#14213D",
      plotBorderWidth: 1,
      borderColor: "#E5E7EB",
      // plotBackgroundColor: "#FCA31150",
      zoomType: "x",
    },
    xAxis: {
      type: "datetime",
      crosshair: true,
      labels: {
        style: {
          color: "#374151",
        },
      },
      lineColor: "#E5E7EB",
      tickColor: "#E5E7EB",
    },

    yAxis: [
      {
        // 컨센차트
        title: {
          text: "컨센서스(억)",
          style: {
            color: "#374151",
          },
        },
        gridLineColor: "#E5E7EB",
        labels: {
          style: {
            color: "#374151",
          },
        },

        opposite: false,
      },
      {
        title: {
          // 주가차트
          text: "주가(원)",
          style: {
            color: "#374151",
          },
        },

        gridLineColor: "transparent",
        labels: {
          style: {
            color: "#374151",
          },
        },
      },
    ],
    rangeSelector: {
      buttonTheme: {
        // styles for the buttons
        fill: "none",
        stroke: "none",
        "stroke-width": 0,
        r: 8,
        style: {
          color: "#374151",
          fontWeight: "bold",
        },
        states: {
          select: {
            fill: "#E5E7EB",
            style: {
              color: "#1F2937",
            },
          },
        },
      },
      inputStyle: {
        color: "#374151",
      },
      labelStyle: {
        color: "#374151",
      },
    },
    navigator: {
      height: 20,
      series: {
        color: "#E5E7EB",
        lineColor: "#9CA3AF",
      },
      xAxis: {
        gridLineColor: "#E5E7EB",
      },
    },

    scrollbar: {
      // 스크롤바
      height: 1,
      barBackgroundColor: "#E5E7EB",
      trackBackgroundColor: "#F3F4F6",
    },
    legend: {
      itemStyle: {
        color: "#374151",
        fontSize: "0.8rem",
      },
      itemHiddenStyle: {
        color: "#9CA3AF",
      },
      enabled: true,
    },
    tooltip: {
      borderRadius: 20,
      valueDecimals: 0,
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      style: {
        color: "#333333",
      },
      shadow: {
        color: 'rgba(0,0,0,0.1)',
        width: 8,
        offsetX: 0,
        offsetY: 2
      },
      borderWidth: 0,
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        turboThreshold: 0,
      },
      candlestick: {
        lineColor: "#0EA5E9",
        color: "#0EA5E9",
        upLineColor: "#E11D48", // docs
        upColor: "#E11D48",
      },
    },
  };

  const [options, setOptions] = useState(base_options);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const today = new Date();
    const this_year = today.getFullYear().toString() + "12";
    const next_year = (today.getFullYear() + 1).toString() + "12";
    getConsensusChartData(company_id, this_year)
      .then((this_res) => {
        // chart data 셋업

        const series = [
          {
            data: this_res.revenues,
            name: `${this_year.slice(0, 4)}년 매출 컨센서스`,
            color: "#2563EB",
            visible: true,
            showInNavigator: false,
          },
          {
            data: this_res.operatingProfits,
            name: `${this_year.slice(0, 4)}년 영업이익 컨센서스`,
            color: "#F59E0B",
            visible: false,
          },
        ];
        getConsensusChartData(company_id, next_year).then((next_res) => {
          series.push({
            data: next_res.revenues,
            name: `${next_year.slice(0, 4)}년 매출 컨센서스`,
            color: "#9333EA",
            visible: false,
            // showInNavigator: true,
          });
          series.push({
            data: next_res.operatingProfits,
            name: `${next_year.slice(0, 4)}년 영업이익 컨센서스`,
            color: "#DC2626",
            visible: false,
            // showInNavigator: true,
          });

          const title = {
            style: {
              color: "#111827",
              fontWeight: "bold",
            },
            text: `${name} 컨센서스 추이`,
          };

          getStockChartData(company_id).then((res) => {
            // chart data 셋업

            series.push({
              type: "candlestick",
              data: res,
              events: {
                click: function (e) {
                  console.log(e);
                },
              },
              name: "주가",
              yAxis: 1,
              showInNavigator: true,
            });

            setOptions((prev) => {
              const temp = {
                ...prev,
                series,
                title,
              };
              return temp;
            });
          });
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [company_id]);
  return (
    <div className="w-full">
      <div
        className={`w-full text-center bg-gray-100 text-gray-500 p-5 rounded my-2 text-xlg font-bold ${
          !isLoading && "hidden"
        }`}
      >
        ....loading....
      </div>

      <div className={`${isLoading ? "hidden" : ""}`}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          constructorType={"stockChart"}
        />
      </div>
    </div>
  );
}
